import { render, staticRenderFns } from "./BtnFinalizarRequisicao.vue?vue&type=template&id=f0f46936"
import script from "./BtnFinalizarRequisicao.vue?vue&type=script&lang=js"
export * from "./BtnFinalizarRequisicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports